const API_KEY = process.env.REACT_APP_CONST_API_KEY;
const BASE = process.env.REACT_APP_CONST_BASE;
const IMG = process.env.REACT_APP_CONST_IMG;
const USE_MOCK = false;

export { API_KEY, BASE, IMG, USE_MOCK };
